import { render, staticRenderFns } from "./MyWalletGetGasTokenToReceive.vue?vue&type=template&id=290796bc&scoped=true"
import script from "./MyWalletGetGasTokenToReceive.vue?vue&type=script&lang=ts"
export * from "./MyWalletGetGasTokenToReceive.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletGetGasTokenToReceive.vue?vue&type=style&index=0&id=290796bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290796bc",
  null
  
)

export default component.exports